import { useEffect, useState } from "react";
import "./App.css";
import MovieContainer from "./MovieContainer";

import CssBaseline from '@mui/material/CssBaseline';

function App() {


  return (
    <div>
      <CssBaseline/>
      <MovieContainer></MovieContainer>
      
    </div>
  );
}

export default App;
